module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "kiwi-buffersettings"
  }, [_c('div', {
    staticClass: "kiwi-buffersettings-alerts"
  }, [_c('form', {
    staticClass: "u-form"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('settings_notify')) + ": ")]), _c('br'), _vm._v(" "), _c('label', [_c('span', [_vm._v(_vm._s(_vm.$t('settings_notify_all')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settingAlertOn),
      expression: "settingAlertOn"
    }],
    attrs: {
      "type": "radio",
      "name": "alert_on",
      "value": "message"
    },
    domProps: {
      "checked": _vm._q(_vm.settingAlertOn, "message")
    },
    on: {
      "__c": function($event) {
        _vm.settingAlertOn = "message"
      }
    }
  })]), _c('br'), _vm._v(" "), _c('label', [_c('span', [_vm._v(_vm._s(_vm.$t('settings_notify_mentioned')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settingAlertOn),
      expression: "settingAlertOn"
    }],
    attrs: {
      "type": "radio",
      "name": "alert_on",
      "value": "highlight"
    },
    domProps: {
      "checked": _vm._q(_vm.settingAlertOn, "highlight")
    },
    on: {
      "__c": function($event) {
        _vm.settingAlertOn = "highlight"
      }
    }
  })]), _c('br'), _vm._v(" "), _c('label', [_c('span', [_vm._v(_vm._s(_vm.$t('settings_notify_never')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settingAlertOn),
      expression: "settingAlertOn"
    }],
    attrs: {
      "type": "radio",
      "name": "alert_on",
      "value": "never"
    },
    domProps: {
      "checked": _vm._q(_vm.settingAlertOn, "never")
    },
    on: {
      "__c": function($event) {
        _vm.settingAlertOn = "never"
      }
    }
  })]), _c('br'), _vm._v(" "), _c('label', [_c('span', [_vm._v(_vm._s(_vm.$t('settings_notify_mute')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settingMuteSound),
      expression: "settingMuteSound"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.settingMuteSound) ? _vm._i(_vm.settingMuteSound, null) > -1 : (_vm.settingMuteSound)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.settingMuteSound,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.settingMuteSound = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.settingMuteSound = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.settingMuteSound = $$c
        }
      }
    }
  })]), _c('br')])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-8a6ad7e4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/BufferSettings.vue
// module id = 500
// module chunks = 2